// frontend/js/main.js
// ==========================================
// 把 SCSS 入口拉進來，Webpack 會連動編譯
import '../scss/main.scss';
import '../scss/404.scss';
// ==========================================
(function () {

    function MainPage() {
        const that = this;
        const _mgr = new function () {};  // 你要放管理用變數、設定，都可以

        // ---------------------------
        // 區塊：負責組 HTML 字串
        // ---------------------------
        that.BuildHTML = new function () {
        };

        // ---------------------------
        // 區塊：通用工具
        // ---------------------------
        that.CommonFunction = new function () {

            this.onEventListener = function(el, evt, sel, handler) {
                el.addEventListener(evt, function(event) {
                    let t = event.target;
                    while (t && t !== this) {
                        if (t.matches(sel)) {
                            handler.call(t, event);
                        }
                        t = t.parentNode;
                    }
                });
            };

            this.getParents = function(elem, selector) {
                if (!Element.prototype.matches) {
                    Element.prototype.matches =
                        Element.prototype.matchesSelector ||
                        Element.prototype.mozMatchesSelector ||
                        Element.prototype.msMatchesSelector ||
                        Element.prototype.oMatchesSelector ||
                        Element.prototype.webkitMatchesSelector ||
                        function(s) {
                            const matches = (this.document || this.ownerDocument).querySelectorAll(s);
                            let i = matches.length;
                            while (--i >= 0 && matches.item(i) !== this) {}
                            return i > -1;
                        };
                }

                for (; elem && elem !== document; elem = elem.parentNode) {
                    if (elem.matches(selector)) return elem;
                }
                return null;
            };

            this.formatPriceNumber = function(strNumber) {
                if (typeof strNumber === 'number') {
                    strNumber = Math.ceil(strNumber).toString();
                } else {
                    strNumber = Math.ceil(Number(strNumber)).toString();
                }

                for (let i = strNumber.length - 3; i > 0; i -= 3) {
                    strNumber = strNumber.substring(0, i) + ',' + strNumber.substring(i);
                }
                return strNumber;
            };
        };

        // ---------------------------
        // 區塊：實際業務邏輯
        // ---------------------------
        that.doFunction = new function () {
        };

        // ---------------------------
        // 區塊：初始化流程
        // ---------------------------
        that.initFunction = new function () {

            this.init = async function () {
            };

            this.initRegisterEvent = function () {
                that.CommonFunction.onEventListener(document, 'click', '.header-logout', async function(event) {
                    try {
                        const res = await fetch('/logout', {
                            method: 'POST',
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded',
                                'CSRF-Token': csrfToken
                            },
                            body: new URLSearchParams({}),
                            cache: 'no-store'
                        });

                        // ✅ 302 / 303 / 307 / 308：前端自行導頁
                        if (res.type === 'opaqueredirect' || (res.status >= 300 && res.status < 400)) {
                            // 同源情況通常讀得到 Location；讀不到就用你要的 '/'
                            const to = res.headers.get('Location') || '/';
                            location.href = to; // 或直接 '/'
                            return;
                        }
                        // ✅ 非 JSON 就別硬 parse
                        const ct = res.headers.get('content-type') || '';
                        if (!ct.includes('application/json')) {
                            location.href = '/';
                            return;
                        }

                        // ✅ 只 parse 一次
                        const jsonData = await res.json();

                        // ✅ 失敗：顯示後端 message（你可以改成塞到 invalidMsg）
                        if (!res.ok || !jsonData.success) {
                            throw new Error(jsonData.message || '登出失敗');
                        }

                        // ✅ 成功導頁
                        location.href = jsonData.redirectTo || '/login';

                    } catch (err) {
                        console.log('POST /logout err：', err);
                        alert(err.message || '登出失敗');
                    }
                });

                that.CommonFunction.onEventListener(document, 'click', '.mobileNavbar-toggle', function(event) {
                    event.stopPropagation();
                    event.preventDefault();

                    const DOM_mobileNavbarMenu = document.querySelector('.mobileNavbarMenu');
                    if(DOM_mobileNavbarMenu.classList.contains('active')) {
                        DOM_mobileNavbarMenu.classList.remove('active');
                    }
                    else {
                        DOM_mobileNavbarMenu.classList.add('active');
                    }
                });

                that.CommonFunction.onEventListener(document, 'click', '.mobileNavbarMenu .close', function(event) {
                    event.stopPropagation();
                    event.preventDefault();

                    const DOM_mobileNavbarMenu = document.querySelector('.mobileNavbarMenu');
                    DOM_mobileNavbarMenu.classList.remove('active');
                });
            };
        };
    }

    // ==========================================
    // ✅ 5. 等 window load 再啟動 MainPage
    // ==========================================
    window.addEventListener('load', function () {
        const mainManager = new MainPage();
        mainManager.initFunction.initRegisterEvent();
        mainManager.initFunction.init();
    });

})();